import { API as AwsAPI } from '@aws-amplify/api'
import store from '@/store/index'
import router from '@/router/index'
import i18n from '@/lang'

/**
 * API
 */
export class API {
  /**
   * get
   *
   * @param {string} url
   * @param {object} options
   * @returns {object} response
   */
  static async get(url, options) {
    let response = null

    for (const key in options) {
      // 空配列をクエリパラメータから削除。APIGatewayでエラーとなったので。
      if (Array.isArray(options[key]) && options[key].length == 0) {
        delete options[key]
      }
    }

    let params = {}
    if (options) {
      params.queryStringParameters = options
    }

    try {
      response = await AwsAPI.get('API', url, params)
    } catch (error) {
      this.handleError(error)
      throw error
    }
    return response
  }

  /**
   * post
   *
   * @param {string} url
   * @param {object} body
   * @returns {object} response
   */
  static async post(url, body) {
    let response = null

    let params = {}
    if (body) {
      params = body
    }

    try {
      response = await AwsAPI.post('API', url, { body: params })
    } catch (error) {
      this.handleError(error)
      throw error
    }

    return response
  }

  /**
   * エラーハンドリング
   *
   * @param {object} error
   */
  static async handleError(error) {
    if (error == 'No current user' || error.code == 'NotAuthorizedException') {
      // No current user: ブラウザのキャッシュクリア等でlocalstorageからCognito認証済み情報が消える
      // NotAuthorizedException: Cognito認証切れエラー
      await store.dispatch('doSignOut')
      router
        .push({ path: '/sign-in' })
        .then(() => {
          store.dispatch('doSetMessageInfo', { type: 'error', message: i18n.t('MSG0121') })
        })
        .catch(() => {})
    }
  }
}
